import React from "react";
import ProceduresContext from "./ProceduresContext";
import { Paper, Divider, IconButton, Menu, MenuItem, CircularProgress } from "@material-ui/core";
import styled from "styled-components";
import ProceduresListHeader from "./ProceduresListHeader";
import "../../App.scss";
import ProceduresListItem from "./ProceduresListItem";
import ProceduresEditableListItem from "./ProceduresEditableListItem";
import ProceduresArchivedListItem from "./ProceduresArchivedListItem";
import LoadProcedures from '../projects/LoadProcedures';
import Button from "@material-ui/core/Button";
import ArchiveIcon from "@material-ui/icons/Archive";
import ArrowBack from "@material-ui/icons/ArrowBack";
import ProceduresMenuButton from './ProceduresMenuButton';
import ProceduresSearch from './ProceduresSearch';
import ProceduresCategoryFilter from './ProceduresCategoryFilter';
import ProceduresStatusFilter from './ProceduresStatusFilter';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1300px) {
    justify-content:left;
  }
`;

const CircularProgressContainer = styled.div`
   width:100%;
   align-items:center;
   justify-content:center;
   display:flex;
`;

const SubContainer = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
`;

const PaperContainer = styled.div`
  width: 100%;
`;

const Title = styled.div``;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  justify-content: space-between;
  padding: 20px;
  height:76px;
`;


const AddButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const AddProcedureContainer = styled.div`
  display: flex;
  justify-content: center;
  width:190px;
  padding-left:5px;
`;

const DisplayMenuContainer = styled.div`
  display: flex;
  justify-content: center;
  width:44px;
  padding-left:20px;
  margin-right:20px;
`;

const AddCategoriesContainer = styled.div`
  display: flex;
  justify-content: center;
  width:190px;
`;

const ArchiveButtonContainer = styled.div`
  display: flex;
  justify-content:flex-end;
  width:100%;
  align-items:center;
  padding-top:20px;
  padding-bottom:20px;
  padding-right:20px;
`;

const BackToProceduresContainer = styled.div`
  padding-left:10px;
  padding-top:10px;
`;

const EmptyStateContainer = styled.div`
  height:200px;
  width:100&
  padding:20px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-family: Roboto;
  font-size: 20px;
  color:gray;
`;

const SearchContainer = styled.div`
  display:flex;
  align-items:center;
  justify-content: space-between;
`;

class ProceduresList extends React.Component {
  static contextType = ProceduresContext;
  state = {
    anchorEl: null
  }
  componentDidMount() {
    this.context.displayArchivedProcedures(false);
  }

  render() {
    const { procedures, isProjectSpecific } = this.context;

    if (procedures.addingToWorkflow) {
      return <CircularProgressContainer
        style={{ height: window.innerHeight - 200 }}
      >
        <CircularProgress />
      </CircularProgressContainer>
    }

    const selectedFunction = (this.context.isProjectSpecific || this.context.isProjectSpecificCorporate) ? procedures.selectedProjectFunction : procedures.selectedFunction;
    let proceduresList = procedures.procedures;

    let emptyStateMessage = "";

    if (this.context.isProjectSpecific) {

      proceduresList = procedures.projectSpecificProcedures;

    } else if (this.context.isProjectSpecificCorporate) {
      proceduresList = procedures.projectSpecificCorporateProcedures;

      if (proceduresList.length === 0 && !this.context.shouldDisplayArchivedProcedures) {
        emptyStateMessage = "Load procedures to populate them in your workflow.";
      }

    }

    const shouldShowLoadProceduresButton = this.context.isProjectSpecificCorporate;

    proceduresList = this.context.sortProceduresList(proceduresList);

    const { procedureBeingEdited, selectedProject } = procedures;

    // apply search filter
    proceduresList = !this.context.searchText ? proceduresList : proceduresList.filter(procedure => {
      return `${procedure.sdn} ${procedure.name}`.toUpperCase().includes(this.context.searchText.toUpperCase());
    });

    // apply category filter
    proceduresList = !this.context.categoryFilterText || this.context.categoryFilterText === 'All' ? proceduresList : proceduresList.filter(procedure => {
      const categoryName = procedure.categoryName;
      return `${categoryName}`.toUpperCase() === (this.context.categoryFilterText.toUpperCase());
    });

    // apply status filter
    proceduresList = this.context.statusFilterText === '' || this.context.statusFilterText === 'All' ? proceduresList : proceduresList.filter(procedure => {
      if (this.context.statusFilterText) {
        return procedure.isNew === true;
      } else {
        return procedure.isNew === false;
      }
    });


    const procedureBeingAdded =
      procedureBeingEdited && !procedureBeingEdited.id;
    const currentOmFunctions = this.context.aboutCurrentUser.permissions.filter(x => x.hasRole === true && x.scope === 'FUNC' && x.assetId).map(t => t.assetId);
    const canCurrentUserEditProcedures = this.context.aboutCurrentUser.isProjectLevelApprover || this.context.aboutCurrentUser.isGbuAdmin || (this.context.aboutCurrentUser.isOM && currentOmFunctions.some(x => x === selectedFunction.id)) || this.context.canCurrentUserEditProcedures;

    return (
      <Container>
        {selectedFunction && procedures && (
          <SubContainer>
            <Paper>
              <PaperContainer>
                {this.context.shouldDisplayArchivedProcedures &&
                  <BackToProceduresContainer>
                    <Button
                      color="primary"
                      onClick={() => this.context.displayArchivedProcedures(false)}
                    >
                      <ArrowBack />
                      <span style={{ paddingLeft: 10 }}>{`Back To Procedures`}</span>
                    </Button>
                  </BackToProceduresContainer>
                }
                <HeaderContainer>
                  <Title className="app-header-title">
                    {this.context.shouldDisplayArchivedProcedures ? `${selectedFunction.name} Procedures Archive` : `${selectedFunction.name} Procedures`}
                  </Title>
                </HeaderContainer>
                <SearchContainer>
                  <AddButtonContainer>
                    {!this.context.shouldDisplayArchivedProcedures && <ProceduresSearch />}
                    {!this.context.shouldDisplayArchivedProcedures && <ProceduresStatusFilter />}
                    {!this.context.shouldDisplayArchivedProcedures && !this.context.isProjectSpecific && <ProceduresCategoryFilter />}
                  </AddButtonContainer>
                  {(!this.context.shouldDisplayArchivedProcedures && (!this.context.isProjectSpecificCorporate) && (canCurrentUserEditProcedures)) &&
                    <AddButtonContainer>
                      {!this.context.isProjectSpecific &&
                        <AddCategoriesContainer >
                          <Button
                            fullWidth
                            color="primary"
                            variant="outlined"
                            onClick={() => { this.context.displayCategoriesDialog() }}
                          >
                            Add/Edit Categories
                          </Button>
                        </AddCategoriesContainer>
                      }
                      <AddProcedureContainer>
                        <Button
                          fullWidth
                          color="primary"
                          variant="contained"
                          onClick={() => this.context.addProcedure((selectedProject && isProjectSpecific) ? selectedProject.id : undefined)}
                        >
                          + Add Procedure
                        </Button>
                      </AddProcedureContainer>
                      <DisplayMenuContainer>
                        < ProceduresMenuButton />
                      </DisplayMenuContainer>
                    </AddButtonContainer>
                  }
                  {shouldShowLoadProceduresButton &&
                    <AddButtonContainer>
                      <AddProcedureContainer>
                        <LoadProcedures />
                      </AddProcedureContainer>
                    </AddButtonContainer>
                  }
                </SearchContainer>
                <Divider />
                <>
                  <ProceduresListHeader />
                  <Divider />
                </>
                {emptyStateMessage &&
                  <EmptyStateContainer>
                    <div>
                      {emptyStateMessage}
                    </div>
                  </EmptyStateContainer>
                }
                {procedureBeingAdded && (
                  <ProceduresEditableListItem
                    selectedFunction={selectedFunction}

                    context={this.context}
                    procedure={procedureBeingEdited}
                  />
                )}
                {
                  !this.context.shouldDisplayArchivedProcedures && proceduresList.filter(procedure => !procedure.archived).map(procedure => {
                    if (
                      procedureBeingEdited &&
                      procedure.id === procedureBeingEdited.id
                    ) {
                      return (
                        <ProceduresEditableListItem
                          context={this.context}
                          selectedFunction={selectedFunction}
                          procedure={procedure}
                          key={procedure.id}
                        />
                      );
                    } else {
                      return (
                        <ProceduresListItem
                          selectedFunction={selectedFunction}
                          context={this.context}
                          procedure={procedure}
                          key={procedure.id}
                          isProjectSetupPage={this.context.isProjectSpecificCorporate || false}
                        />
                      );
                    }
                  })}
                {this.context.shouldDisplayArchivedProcedures && proceduresList.filter(procedure => procedure.archived).map(procedure => <ProceduresArchivedListItem key={procedure.id} procedure={procedure} />)}
                {(!this.context.shouldDisplayArchivedProcedures) &&
                  <ArchiveButtonContainer>
                    <Button
                      color="primary"
                      onClick={() => this.context.displayArchivedProcedures(true)}
                    >
                      <span style={{ paddingRight: 10 }}>{`VIEW ARCHIVE`}</span>
                      <ArchiveIcon />
                    </Button>
                  </ArchiveButtonContainer>
                }
              </PaperContainer>
            </Paper>
          </SubContainer>
        )}
      </Container>
    );
  }
}

export default ProceduresList;
